export default "__VITE_PUBLIC_ASSET__c0bcac3b__"